import { createFileRoute, redirect } from '@tanstack/react-router'
import { OpeningBalancesIndexScreen } from '@/features/accounting-opening-balances/opening-balances-index-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/opening-balances/')({
  // Presentation only — the API enforces accounting_opening.view on every
  // read. This keeps a user without the grant out of a screen they cannot
  // use, and the rail entry hides under the same key, so the two can never
  // disagree.
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_opening.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: OpeningBalancesIndexScreen,
})
